import { useNavigate } from "react-router-dom";
import { LoginForm as BaseLoginForm } from "@racoon/ui";
import {
  useLoginMutation,
  useRequestOTPMutation,
  useLoginOTPMutation,
} from "~/shared/api/auth/auth.grpc";

export const LoginOtpPage = () => {
  const navigate = useNavigate();

  const loginMutation = useLoginMutation();
  const requestOtpMutation = useRequestOTPMutation();
  const loginOtpMutation = useLoginOTPMutation();

  const handleSuccess = () => {
    navigate("/select-company");
  };

  return (
    <BaseLoginForm
      loginMutation={loginMutation as any}
      sendOtpMutation={requestOtpMutation as any}
      loginOtpMutation={loginOtpMutation as any}
      onSuccess={handleSuccess}
      defaultMode="otp"
      isGrpc={true}
    />
  );
};
